import React, { useMemo } from 'react';
import useLayoutContext from '@hooks/useLayoutContext';
import { FCWithChildren } from '@types';
import { getSubdomain } from '@utils';
// @ts-ignore
import BoldynEuaPdf from '@assets/documents/boldyn-end-user-agreement.pdf';
// @ts-ignore
import MilitaryEuaPdf from '@assets/documents/dod-end-user-agreement.pdf';
// @ts-ignore
import SamHoustonEuaPdf from '@assets/documents/sam-houston-end-user-agreement.pdf';

const SUBDOMAIN = getSubdomain();

type TermsLinkProps = React.ComponentPropsWithoutRef<'a'>;

const TermsLink: FCWithChildren<TermsLinkProps> = ({
  children = 'Terms and Conditions',
  ...props
}) => {
  const { isMilitary } = useLayoutContext();

  const EuaPdf = useMemo(() => {
    const parsed = SUBDOMAIN.startsWith('samhouston') ? 'samhouston' : SUBDOMAIN;
    switch (parsed) {
      case 'samhouston':
      case 'verifymil1':
        return SamHoustonEuaPdf;
      default:
        return isMilitary ? MilitaryEuaPdf : BoldynEuaPdf;
    }
  }, [isMilitary]);

  return (
    <a href={EuaPdf} target="_blank" rel="noreferrer noopener" {...props}>
      {children}
    </a>
  );
};

export default TermsLink;
